import { type FormEvent, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../auth/AuthContext.tsx'
import { changePassword } from '../lib/api.ts'

export function AccountPage() {
  const { ready, authenticated, username } = useAuthContext()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [repeat, setRepeat] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)

  if (ready && !authenticated) return <Navigate to="/login" replace />

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    if (next.length < 8) return setError('Nytt lösenord måste vara minst 8 tecken')
    if (next !== repeat) return setError('Lösenorden matchar inte')
    setBusy(true)
    try {
      await changePassword(current, next)
      setDone(true)
      setCurrent('')
      setNext('')
      setRepeat('')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Kunde inte byta lösenord')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="loginpage">
      <div className="card card__pad">
        <h1>Byt lösenord</h1>
        <p className="muted">Inloggad som {username}.</p>

        {done && <div className="notice">Lösenordet är ändrat.</div>}
        {error && <div className="notice notice--error">{error}</div>}

        <form onSubmit={submit} className="grid" style={{ gap: 14, maxWidth: 340 }}>
          <div className="field">
            <label htmlFor="cur">Nuvarande lösenord</label>
            <input
              id="cur"
              type="password"
              autoComplete="current-password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="new">Nytt lösenord</label>
            <input
              id="new"
              type="password"
              autoComplete="new-password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              required
              minLength={8}
            />
          </div>
          <div className="field">
            <label htmlFor="rep">Upprepa nytt lösenord</label>
            <input
              id="rep"
              type="password"
              autoComplete="new-password"
              value={repeat}
              onChange={(e) => setRepeat(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? 'Byter …' : 'Byt lösenord'}
          </button>
        </form>
      </div>
    </div>
  )
}
